import i18n from "i18next";

export const getMeaning = (vocab: { meaning: string | { [lang: string]: string } }) => {
  const lang = i18n.language;
  return typeof vocab.meaning === "string" ? vocab.meaning : vocab.meaning?.[lang] || vocab.meaning?.["zh"] || "";
}